import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import InterviewSession from "./coordinator/InterviewSession.jsx";

/**
 * An interview link (David, Oct 29): someone asked to answer an interview,
 * with no account and no password. Opening the link lets this browser answer
 * that one interview; coming back with it carries on where they left off.
 *
 * Wording is a first draft for David.
 */
export default function InterviewLinkEntry() {
  const { token } = useParams();
  const [opened, setOpened] = useState(null);   // { client_id, interview_id }
  const [fatal, setFatal]   = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`/api/interview-links/${encodeURIComponent(token)}/open`, { method: "POST" });
        const d = await r.json().catch(() => ({}));
        if (cancelled) return;
        if (!r.ok) { setFatal(d.error || "This link isn't valid."); return; }
        setOpened(d);
      } catch {
        if (!cancelled) setFatal("We couldn't open that link. Check your connection and try again.");
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  if (opened) {
    return <InterviewSession clientId={opened.client_id} interviewId={opened.interview_id} />;
  }
  return (
    <div style={s.page}>
      <div style={s.card}>
        {fatal ? (
          <>
            <h1 style={s.heading}>This link can't be opened</h1>
            <p style={s.body}>{fatal}</p>
          </>
        ) : (
          <p style={s.body}>Opening…</p>
        )}
      </div>
    </div>
  );
}

const s = {
  page:    { minHeight: "100dvh", background: "var(--color-bg-subtle)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 },
  card:    { background: "var(--color-surface)", border: "1px solid var(--color-border)", borderRadius: "var(--radius-xl)", padding: "40px 36px", width: "100%", maxWidth: 440 },
  heading: { fontSize: "var(--text-lg)", fontWeight: "var(--weight-semibold)", color: "var(--color-text-primary)", marginBottom: 12, lineHeight: "1.35" },
  body:    { fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", lineHeight: "var(--leading-normal)", margin: 0 },
};
